import { motion } from "framer-motion";
import { Check, Globe, Cpu, ShoppingBag } from "lucide-react";

const features = [
  {
    icon: Globe,
    title: "Limbaj Românesc Nativ",
    description: "AI-ul nostru înțelege jargonul local, expresii și context cultural românesc.",
  },
  {
    icon: ShoppingBag,
    title: "Platforme Populare",
    description: "Integrare perfectă cu Gomag, Shopify, WooCommerce și alte platforme din RO.",
  },
  {
    icon: Cpu,
    title: "Optimizare GEO",
    description: "Pregătește-ți site-ul pentru ChatGPT, Perplexity și alte motoare AI.",
  },
];

const benefits = [
  "Schema Markup generat automat",
  "Meta descrieri optimizate pentru AI",
  "Structură de conținut semantică",
  "Monitorizare continuă 24/7",
];

export function DifferentiatorSection() {
  return (
    <section className="py-24 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center max-w-6xl mx-auto">
          {/* Content Side */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent border border-primary/20 mb-6">
              <span className="text-sm font-medium text-accent-foreground">
                🇷🇴 Creat pentru România
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
              Singurul tool de SEO{" "}
              <span className="text-gradient">creat special</span> pentru piața
              românească
            </h2>

            <p className="text-lg text-muted-foreground mb-8">
              Nu mai folosi soluții generice care nu înțeleg specificul pieței
              din România. OptiRO.ai este construit de la zero pentru afaceri
              românești.
            </p>

            <ul className="space-y-3">
              {benefits.map((benefit, index) => (
                <motion.li
                  key={benefit}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.3, delay: 0.1 * index }}
                  className="flex items-center gap-3"
                >
                  <div className="w-5 h-5 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
                    <Check className="w-3 h-3 text-primary-foreground" />
                  </div>
                  <span className="text-foreground">{benefit}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Cards Side */}
          <div className="grid gap-4">
            {features.map((feature, index) => (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 * index }}
                className="card-elevated card-hover p-6 flex items-start gap-4"
              >
                <div className="w-12 h-12 rounded-xl bg-accent flex items-center justify-center flex-shrink-0">
                  <feature.icon className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-foreground mb-1">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground">{feature.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
